import { heroContent } from '@/mocks/homeData';

export default function Hero() {
  const { tag, h1, slogan, intro, stats, ctas } = heroContent;

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100/60 via-background-50 to-primary-50/30"></div>

      <div className="relative w-full px-4 md:px-6 py-24 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-1/2 flex flex-col items-start">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide mb-5">
              <i className="ri-sparkling-line text-sm"></i>
              {tag}
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight tracking-tight mb-4">
              {h1}
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-medium mb-5">
              {slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-7 max-w-lg">
              {intro}
            </p>

            <div className="flex items-center gap-6 mb-8">
              {stats.map((stat, i) => (
                <div key={i} className="flex flex-col items-start">
                  <span className="text-xl md:text-2xl font-heading font-bold text-primary-500">
                    {stat.value}
                  </span>
                  <span className="text-xs text-foreground-500 mt-0.5">{stat.label}</span>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-3">
              {ctas.map((cta, i) =>
                i === 0 ? (
                  <a
                    key={i}
                    href={cta.href}
                    className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-play-circle-line text-lg"></i>
                    {cta.label}
                  </a>
                ) : (
                  <a
                    key={i}
                    href={cta.href}
                    className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 text-sm font-semibold rounded-lg hover:bg-background-100 hover:border-foreground-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {cta.label}
                    <i className="ri-arrow-right-line"></i>
                  </a>
                )
              )}
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex justify-center">
            <div className="relative w-full max-w-lg">
              <div className="relative rounded-xl overflow-hidden aspect-video">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20dramatic%20film%20scenes%2C%20warm%20golden%20lighting%20mixed%20with%20cool%20shadows%2C%20celluloid%20film%20strip%20border%20effect%2C%20professional%20movie%20poster%20quality%2C%20rich%20contrast%2C%20amber%20and%20teal%20color%20grade%2C%20cinephile%20aesthetic&width=900&height=506&seq=hero-visual&orientation=landscape"
                  alt="青柠影院 — 高清电影在线观看平台主视觉"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center gap-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-900 text-xs font-semibold">
                    HD 1080P
                  </span>
                  <span className="px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-semibold">
                    免费观看
                  </span>
                </div>
              </div>

              <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-accent-100 rounded-2xl -z-10 hidden lg:block"></div>
              <div className="absolute -top-4 -right-4 w-20 h-20 bg-primary-100 rounded-2xl -z-10 hidden lg:block"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}